import type { DeviceSrmSetting } from '@/data/DeviceSetting'
import { signalSyncedWithLocalStorage } from '@/react/core/reactive'

export const [testDevices, setTestDevices] = signalSyncedWithLocalStorage('SRM_TESTCASE_DEVICES', null as null | Record<'A' | 'B' | 'C', DeviceSrmSetting | undefined>)
export const [lastSucceededTestcase, setLastSucceededTestcase] = signalSyncedWithLocalStorage('SRM_LAST_SUCCEEDED_TESTCASE', '')
export const [nextTestcase, setNextTestcase] = signalSyncedWithLocalStorage('SRM_NEXT_TESTCASE', '001.001')
